import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { NpBarcodeComponent } from '@newpla/ng-lib';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** NOVA 바코드 QR만 담은 작은 정사각형 상자. NovaBarcodeService.open으로 띄운다 (DOM-SYS-001) */
@Component({
  selector: 'nova-barcode-modal',
  standalone: true,
  imports: [NpBarcodeComponent],
  templateUrl: './nova-barcode-modal.component.html',
  styleUrl: './nova-barcode-modal.component.scss',
  // 모달 dialog 크기는 컴포넌트 밖(.modal-dialog)이라 캡슐화를 끈다
  encapsulation: ViewEncapsulation.None,
})
export class NovaBarcodeModalComponent {

  activeModal = inject(NgbActiveModal);

  /** encodeNovaBarcode 결과 */
  @Input() barcode = '';
  /** 생성기 오류 메시지. 있으면 QR 대신 보여 준다 */
  @Input() error = '';

}
